const TestimonialApi = [
  {
    id: 1,
    image: "./image/slide1.png",
    design: "",
    name: "Java Script",
    offcer: "July 1994",
    post: "Programming Language",
    date: "JavaScript often abbreviated JS, is a programming language that is one of the core technologies of the World Wide Web, alongside HTML and CSS",
    desc: "JavaScript engines were originally used only in web browsers, but are now core components of some servers and a variety of applications. The most popular runtime system for this usage is Node.js.",
  },
  {
    id: 2,
    image: "./image/slide2.png",
    design: "",
    name: "PHP (Personal Home Page)",
    offcer: "1994",
    post: "Programming Language",
    date: "PHP is a general-purpose scripting language geared toward web development",
    desc: "It was originally created by Danish-Canadian programmer Rasmus Lerdorf in 1994. The PHP reference implementation is now produced by The PHP Group. PHP originally stood for Personal Home Page, but it now stands for the recursive initialism PHP: Hypertext Preprocessor.",
  },
  {
    id: 3,
    image: "./image/slide3.png",
    design: "",
    name: "Phyton",
    offcer: "20 February 1991",
    post: "Programming Language",
    date: "Python is a high-level, interpreted, general-purpose programming language.",
    desc: "Its design philosophy emphasizes code readability with the use of significant indentation.Python is dynamically-typed and garbage-collected.",
  },
  {
    id: 4,
    image: "./image/slide4.png",
    design: "",
    name: "C++",
    offcer: "1985",
    post: "Programming Language",
    date: "C++ is a general-purpose programming language",
    desc: "created by Danish computer scientist Bjarne Stroustrup as an extension of the C programming language, or <C with Classes>. The language has expanded significantly over time, and modern C++ now has object-oriented, generic, and functional features in addition to facilities for low-level memory manipulation.",
  },
  {
    id: 5,
    image: "./image/slide5.png",
    design: "",
    name: "C#(see sharp)",
    offcer: "2001",
    post: "Programming Language",
    date: "C# is a general-purpose, multi-paradigm programming language.",
    desc: "C# encompasses static typing, strong typing, lexically scoped, imperative, declarative, functional, generic, object-oriented (class-based), and component-oriented programming disciplines.",
  },
]

export default TestimonialApi
